import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';
import {
  AutoComplete,
  Button,
  Input,
  Modal,
  message,
  Select,
  Space,
} from 'antd';
import React from 'react';
import {
  buildCreatePayload,
  type EntityType,
  useIicData,
} from '@/features/iic-data';
import styles from './index.module.less';

const createTypes: Array<{ value: EntityType; label: string; route: string }> =
  [
    { value: 'leads', label: '线索', route: '/lead' },
    { value: 'enterprises', label: '企业', route: '/enterprise' },
    { value: 'contacts', label: '联系人', route: '/contact' },
    {
      value: 'investmentProjects',
      label: '招商项目',
      route: '/investment-project',
    },
    {
      value: 'enterpriseServices',
      label: '企业服务需求',
      route: '/enterprise-service',
    },
    { value: 'tasks', label: '任务', route: '/workbench' },
  ];

export const GlobalBusinessActions: React.FC = () => {
  const { state, createEntity } = useIicData();
  const [open, setOpen] = React.useState(false);
  const [type, setType] = React.useState<EntityType>('leads');
  const [name, setName] = React.useState('');
  const [submitting, setSubmitting] = React.useState(false);
  const options = React.useMemo(
    () => [
      ...state.enterprises.slice(0, 8).map((item) => ({
        value: item.name,
        label: `企业 · ${item.name}`,
        route: `/enterprise/${item.id}`,
      })),
      ...state.leads.slice(0, 6).map((item) => ({
        value: item.name,
        label: `线索 · ${item.name}`,
        route: `/lead/${item.id}`,
      })),
      ...state.investmentProjects.slice(0, 8).map((item) => ({
        value: item.name,
        label: `项目 · ${item.name}`,
        route: `/investment-project/${item.id}`,
      })),
    ],
    [state],
  );

  const create = async () => {
    if (!name.trim()) return;
    setSubmitting(true);
    try {
      await createEntity(
        type,
        buildCreatePayload(type, name.trim(), state) as { name: string },
      );
      const config = createTypes.find((item) => item.value === type);
      setOpen(false);
      setName('');
      message.success(`已新建${config?.label}`);
      if (config) history.push(config.route);
    } catch (error) {
      if (error instanceof Error && !(error as any).handled) {
        message.error(error.message);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <AutoComplete
        className={styles.globalSearch}
        options={options}
        filterOption={(input, option) =>
          String(option?.label).toLowerCase().includes(input.toLowerCase())
        }
        onSelect={(_, option) =>
          history.push((option as { route: string }).route)
        }
      >
        <Input
          prefix={<SearchOutlined />}
          placeholder="搜索企业、联系人、项目、线索"
          allowClear
        />
      </AutoComplete>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => setOpen(true)}
      >
        新建
      </Button>
      <Modal
        open={open}
        title="快捷新建"
        okText="保存并打开"
        confirmLoading={submitting}
        onOk={() => void create()}
        onCancel={() => setOpen(false)}
      >
        <Space direction="vertical" style={{ width: '100%' }} size={14}>
          <Select
            value={type}
            style={{ width: '100%' }}
            options={createTypes}
            onChange={setType}
          />
          <Input
            autoFocus
            placeholder="请输入名称"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </Space>
      </Modal>
    </>
  );
};
